module.exports = __webpack_public_path__ + "images/screen-shots/conference_reports-2990df69e586efce0c62b15173098efe.png";